"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));
var _Title = _interopRequireDefault(require("./Title"));
var _excluded = ["title", "titleStyle", "openIcon", "closedIcon", "startOpen", "content", "sectionStyle", "triggerStyle"];
var CollapsibleSection = function CollapsibleSection(props) {
  var title = props.title,
    titleStyle = props.titleStyle,
    openIcon = props.openIcon,
    closedIcon = props.closedIcon,
    startOpen = props.startOpen,
    content = props.content,
    sectionStyle = props.sectionStyle,
    triggerStyle = props.triggerStyle,
    others = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactCollapsible["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
      style: sectionStyle
    }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
      style: titleStyle
    }, title), closedIcon),
    triggerWhenOpen: /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
      style: sectionStyle
    }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
      style: titleStyle
    }, title), openIcon),
    open: startOpen
  }, content);
};
var _default = exports["default"] = CollapsibleSection;